var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"600px"}},[_c('div',{staticClass:"heading1"},[_vm._v(" Inflammatory Arthritis Care Map Coming Soon ")])])}]

export { render, staticRenderFns }